export enum AssessmentType {
  FORMATIVE = "formative",
  SUMMATIVE = "summative",
}

export enum EnrichmentStatus {
  COMPLETE = "complete",
  INCOMPLETE = "incomplete",
  CORRECT = "correct",
  INCORRECT = "incorrect",
}

export type EnrichmentStatusDictionary = {
  [enrichmentId: string]: EnrichmentStatus;
};

export interface EnrichmentItem {
  id: string;
  cfi: string;
  status: EnrichmentStatus;
  type: AssessmentType;
  count: number;
}

export interface ManifestItem {
  id: string;
  source: "checkpoint";
  type: "assessments";
  cfi: string;
  title: null;
  metadata: {
    assessment_type: AssessmentType;
    contents_count: number;
  };
}

export interface LoadEnrichmentResponse {
  result: { status: EnrichmentStatusDictionary };
}

export interface LoadEnrichmentStatusParams {
  enrichmentIds: string[];
}

export const LOAD_MANIFEST_PREFIX = "enrichments/manifest/load";
export const INIT_SERVICE_PREFIX = "tightrope/init";
export const LOAD_ENRICHMENT_STATUS_PREFIX = "tightrope/enrichmentStatus/load";
